module.exports = __webpack_public_path__ + "static/media/x.36ee2fcd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/x.svg
// module id = 609
// module chunks = 0